import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function MidCTA() {
  return <section className="py-5 px-6 bg-midnight-light border-t border-gold/10" data-id="element-93">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 1
    }} className="max-w-sm mx-auto text-center" data-id="element-94">
        <p className="font-sans text-xs text-gray-500 font-light mb-3 tracking-wide" data-id="element-95">
          Cada minuto que pasa, el ciclo se repite.
        </p>
        <a href="https://tutiendadigi.shop/cart/51868811428120:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="block w-full py-5 bg-gold text-black font-sans font-semibold text-sm tracking-[0.15em] uppercase text-center hover:bg-gold-light transition-colors duration-300" data-id="element-96">
          acceso inmediato — $14.990
        </a>
      </motion.div>
    </section>;
}